export { default } from './TermsAndConditions';
export const CONTENT_TERMS_ANCHOR_ID = 'terms-and-conditions';
